<ng-container [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      REFERENCE ENTITY / OBLIGATION(S)
    </h5>
  </div>

  <div class="modal-body container" ngbAutofocus>
    <div class="form-row topRow">
      <div class="form-group col-2 performanceType">
        <app-dc-select
          formControlName="performanceType"
          [labelId]="'performanceType'"
          [label]="labels.summary.performanceType"
          [items]="performanceTypeItems"
          closeOnSelect="true"
          [clearSelection]="true"
          [readonly]="true"
        ></app-dc-select>
      </div>
      <div class="form-group col-3 settlementType">
        <app-dc-select
          formControlName="settlementType"
          [labelId]="'settlementType'"
          [label]="labels.summary.settlementType"
          [items]="settlementTypeItems"
          closeOnSelect="true"
          [clearSelection]="true"
        ></app-dc-select>
      </div>
    </div>

    <div class="form-row w-100 labelContainer">
      <div class="col-2 col-ref-entity">
        <label class="colHeader">Reference Entity</label>
      </div>
      <div class="col-1 weight">
        <label class="colHeader">Weight</label>
      </div>
      <div class="col-2 standard__obligations">
        <label class="colHeader">Standard Obligations</label>
      </div>
      <div class="col-2">
        <label class="colHeader">Seniority Level</label>
      </div>
      <div class="col-2">
        <label class="colHeader">Transaction Type</label>
      </div>
      <div class="col-3">
        <label class="colHeader">Non-Standard Obligations</label>
      </div>
      <div class="col-1"></div>
    </div>
    <ng-container formGroupName="referenceEntities">
      <app-reference-entities>
        <div
          class="form-group assets"
          *ngFor="
            let entity of referenceEntities.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align align-items-end" [formGroupName]="i">
            <div
              class="form-row w-100"
              *ngIf="form.get('referenceEntities').at(i) as group"
            >
              <div class="col-2 col-ref-entity">
                <app-dc-select
                  #someRef
                  [title]="someRef.control?.displayValue"
                  formControlName="referenceEntityId"
                  [id]="'referenceEntityId'"
                  [items]="
                    selectedEntitiesIds
                      | filterEntities
                        : i
                        : referenceEntityOptions
                        : referenceEntityItems
                  "
                  closeOnSelect="true"
                  searchable="true"
                  clearSelection="true"
                  (selected)="selectEntity($event, entity, i)"
                ></app-dc-select>
              </div>
              <div class="col-1 weight">
                <app-dc-input
                  formControlName="weight"
                  id="weight"
                ></app-dc-input>
              </div>
              <div class="col-2 standard__obligations">
                <app-dc-select
                  [labelId]="'standardReferenceObligations'"
                  [items]="standardObligationsItems"
                  closeOnSelect="true"
                  formControlName="standardReferenceObligations"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div class="col-2">
                <app-dc-input
                  formControlName="seniorityLevel"
                  id="seniorityLevel"
                ></app-dc-input>
              </div>
              <div class="col-2">
                <app-dc-input
                  formControlName="transactionType"
                  id="transactionType"
                ></app-dc-input>
              </div>
              <div class="col-3">
                <app-dc-select
                  formControlName="nonStandardReferenceObligationsList"
                  [id]="'nonStandardReferenceObligationsList'"
                  [items]="getObligationSelectOptions(i)"
                  closeOnSelect="true"
                  clearSelection="true"
                  searchable="true"
                  [multiple]="true"
                  [checkbox]="true"
                  (selected)="selectObligation(entity, i)"
                ></app-dc-select>
              </div>
              <app-dc-plus-minus
                (minusClick)="deleteReference(i)"
                (plusClick)="addReference(null, i + 1)"
                [showPlus]="!i ? first === last : last"
              >
              </app-dc-plus-minus>
            </div>
          </div>
        </div>
      </app-reference-entities>
    </ng-container>
  </div>

  <div class="modal-footer justify-content-right">
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="clearModal()"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">
      Save
    </button>
  </div>
</ng-container>
